<!--
 * @Description: 
 * @Author: 山淑兰
 * @Date: 2019-09-06 15:12:11
 * @LastEditTime: 2020-05-13 17:22:59
 * @LastEditors: 山淑兰
 -->

<template>
  <div class="w-1200">
    <main>
      <HeaderLayout v-if="headData.Code" :headData="headData" />
      <div class="myRerutn" v-if="returnShow" @click="myBack">返回</div>
      <div class="my" v-if="myPersonShow">
        <div class="my-top">
          <img :src="userInfo.Avatar">
          <p>{{userInfo.NickName}}</p>
          <p>{{userInfo.Phone}}</p>
        </div>  
        <div class="my-bot">
          <!-- <div class="my-row">
            参会记录
            <van-icon name="arrow" size="16px" />
          </div> -->
          <div class="my-row" @click="bindPhone">
            修改绑定手机号
          </div>
        </div>
        <!-- <div class="my-bot">
          <div class="my-row" @click="outLogin">
            退出登录
          </div>
        </div> -->
      </div>
      <modifyPhone v-if="modifyPhoneShow"></modifyPhone>
    </main>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import HeaderLayout from "../Components/header.vue";
import modifyPhone from "./modifyPhone.vue";
import { IMeetingInfo, current } from "@/contants/current.ts";
export default {
  name: 'my',
  components: {
    HeaderLayout,
    modifyPhone
  },
  data() {
    return {
      fNavShow: true,
      userInfo: '',
      myShow: true,
      myPersonShow: true,
      modifyPhoneShow: false,
      headData: '',
      returnShow: false
    }
  },
  created() {
    this.myInfo()
    this.InitMeetingInfo()
  },
  methods: {
    async InitMeetingInfo() {
      let params = {
        m: this.$route.query.m,
      };
      let res = await IMeetingInfo.InitMeetingInfo(params);
      if (res.Code === 1000) {
        this.headData = res;
        this.headData.PCBannerImage = ''
      }
    },
    myBack(){
      this.modifyPhoneShow = false
      this.myPersonShow = true
      this.returnShow = false
    },
    bindPhone(){
      this.modifyPhoneShow = true
      this.myPersonShow = false
      this.returnShow = true
      // this.$router.push({
      //     path: '/modifyPhone',
      //     query: this.$route.query,
      // })
    },
    outLogin(){
      this.$confirm('确认退出么?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.clear()
        localStorage.removeItem('wqToken')
        Cookies.remove('wqToken')
        this.$router.push({
          path: '/login',
          query: this.$route.query,
        })
      }).catch(() => {         
      });
    },
    async myInfo() {
      try {
        const params = {m:this.$route.query.m};
        const res = await this.$http.personalCenter.userCentert(params);
        //console.error(res);
        this.userInfo = res
      } catch (error) {
        console.error(error);
      }
    },
  }

};
</script>
<style lang="scss">
.myRerutn{
    font-size: 16px;
    padding: 0 15px;
    cursor: pointer;
    width: 600px;
    margin: 0 auto;
    color: #3b82f6;
    &:hover {
      color: #6366f1;
    }
  }
.my {
  padding-bottom: 85px;
  width: 600px;
  margin: 0 auto;

  .my-top{
    background: linear-gradient(160deg, #1e3a5f 0%, #3b82f6 50%, #6366f1 100%);
    text-align: center;
    padding: 50px 0;
    border-radius: 20px 20px 0 0;
    box-shadow: 0 4px 20px rgba(59,130,246,0.2);
    img{
      width: 100px;
      height: 100px;
      border-radius: 50%;
      border: 3px solid rgba(255,255,255,.3);
    }
    p{
      font-size: 20px;
      color: #fff;
      margin-top:20px;
    }
  }
  .my-bot{
    padding: 0 20px;
    background: #fff;
    margin-bottom: 20px;
    border-radius: 0 0 20px 20px;
    box-shadow: 0 4px 24px rgba(0,0,0,0.06);
    border: 1px solid #e2e8f0;
    border-top: none;

    .my-row{
      font-size: 16px;
      color: #475569;
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #e2e8f0;
      cursor: pointer;
      transition: all 0.2s;
      &:hover {
        color: #6366f1;
        padding-left: 8px;
      }
    }
    .my-row:last-child{
      border-bottom: none;
    }
  }
}

</style>


